export enum ProjectGrant {
  manage = 'manage',
  read = 'read',
  write = 'write',
  owner = 'owner',
}
